export default __webpack_public_path__ + "static/media/incompatibility-icon-blend.0ffe7159.svg";